import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const createGroup = async (payload: Record<string, unknown>) => {
	const response = await cmsClient.post<IGroup>("/users/groups/", payload);

	return response.data;
};

const useCreateGroup = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(<CustomToast type="Success" message="Group created" />, {
			hideProgressBar: true
		});
	};

	const onSettled = () => {
		queryClient.invalidateQueries(["admin-groups"]);
	};

	const onError = (error: unknown) => {
		const detail = (error as { response?: { data?: Record<string, unknown> } })
			?.response?.data;
		const message =
			(detail as { detail?: string })?.detail ??
			(detail ? Object.values(detail).flat().join(" ") : undefined) ??
			"Something went wrong, try again";

		toast.error(<CustomToast type="Error" message={message} />, {
			hideProgressBar: true
		});
	};

	const mutation = useMutation(createGroup, {
		onError,
		onSuccess,
		onSettled
	});

	return mutation;
};

export default useCreateGroup;
